import React from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ButtonComponent from "components/button-component";
import styles from "./exportReport.module.css";
import Text from "components/text";
import { toast } from "react-hot-toast";
import { useState } from "react";
import { Tooltip, Button } from "antd";

function ExportReports({
  data,
  columns,
  accessLevel,
  isLoading,
  editedData,
  reportTitle,
  projectName,
  projAddress,
}) {
  const [exportLoading, setExportLoading] = useState(false);

  const PrintTable = () => {
    const projectInfo = projectName;
    const projectAddress = projAddress;

    const doc = new jsPDF("landscape");

    var base64Img;
    base64Img =
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVMAAAAmCAYAAAB503iyAAAACXBIWXMAABYlAAAWJQFJUiTwAAANL0lEQVR4nO1dW3MjRxU+baCgKGxpQ0KySYi1F/Nq5Q9gOwE2JKlaLYHijmUgJOuX9f6Ctd94i/ZlIVSBJe4hgbUhXEIClvgD2K9ssistm+suu5KdB17woXp0Rh7N9HSfuUgzkuerki2NRtM9p898fc7p091iprGL+wiACCD/74N8j9333eONfYTmPuLGzVO5DYgB4oX38oBYAsR5QCgC4qxVAesFcPAeG4C4DQgb+J3pehxlZ8iQIcMgwCFTeo+S51r7COXbj+VCEZt48WYBEFYBcdGHPBWfe8dagFgFxAp+73jbc/EMGTJkSBATAYueBoCtI3/uVDzfaCB++5+8eOlWFQCuAcCi/5layLIvAEBTPH91RXdihgwZMgwbQS1T57Fa5/Fc2Uykt0sAlkWZU1uebMvU/XlHhgrw7Mmmp9AMGTJkGCEylceW9p7IVz1XtS/+uzsVQDxnsZ+eGDWfted0LEJdnok1niqEKACAqaNoogw7aCCEKAJA3v+MHrYR0Ri6EELMA4B8FejlhrzGNgDUETFcKKZbhg7yvpuO8+U9lqheEvJzk+pi12cDZew7BlDbzFM5RZ8rhpIDXVslVyeMbcWQYVsnj6BtAAd1L5FM7HtY0ZWjKJOjW7ZctTJQXN/vuj0420oIkXfolf27OQBo0Ht5/3XSLW1dHPc2SHw/Kpl2EKHw/pN5z81MXL5TRYRubHRwZNp9ASzh8oyW2IKAhL9l+EkD5QCaD4hkZGPn1Gf0sIlyMM4HpISrpFimaznRAQAZjqkEUXwhBHoO9qOGiGUhRImuP+05Q41GkIdbUS8paxneOe35Uo8WAFQ5chBCrFIoSYcFE0EzZGjSHdPv1xBxFQ7kskpE44a2rkRYK/QKolsSNVmum9T9wJUtkbU895znWzU61Larym/5ZUfFkaAxUzdy1BB9+MDGnWqE2GgYrItLV3wJadggJa0yFHRHZwELISqOOHNQZc/1YsxC+JYRAgWq1+UARAr0sNepk2FDylIIsUGdW1Aihb5Ye7cDGBtQO2z5EKkWQogVsu4uhNAtIJ28RnWIC3kyQLhECraeCyG26blLDFHJFNxu7Ic276wOmUiBeqdY3MiYIIl01nApWeeSyloiAtkOqFR+yFmdjRBxWe7FCPXKEaFq3T0b9HDUQ5KoquzLMXcsiYFILFQ7kC48F5JE3TgnhIgrzMZ5bvwwS79PDFHJtPb+k/meZfrh37fLQzCn3ZCkNI/LM6kYiKIe3/Twd+vs7yLVIyiVHxbJ3YmKqA9gjtw4DgYhh/Wg1nEKMR+BSCsDMHbmYuqso+rWaUa8eWCIQqaNvSfyvV7+I39oy5tY95w1eJRxeSYVVik9pM95vvCi7Bc7JMKLm0BsXEgJkSyaXLKActihFxdxuqZJILBbDwfxVS4JtyjO3fJ8o8ZikkTmQGKeR1gy3aEBEQsffbktH9BYZkcFhBx4SqJcD4gcOHVZQkTleeT+cix7Kf8ziCjkSwa/AeA8WbwmxEUkVh1k2Y46nAlAar6kHkAOF6n8onxRHWqes7yYGwPrNAw41uMmABxDxIIcJJP/5Wc6bkIcng9QGz7s0G9Z/prnLDUSI/QPeo6YYbmoncdzVqzvYy+388xR67hxEc+eTDRG4kKVMSBz0ZBO5RnMU2CHQgS9WCu9r1Ds6p/en/TBIhI/y5iJlk8dNqgO2wxZzJPeqMCRg5Rl33lUhzKRscl6KzPLGTW0aGAJKJ3JAsWKTW1iZWq4D1I4qkQDgboQltStgiZ8xcF5ROzr8Ol6q0KINsPzU92jn57ZmGfoS8Nwnf8GJVOLSO98vkukk39MjEhr+OyJ1DwIzDhpzf3wK+BRZAXKqkEr6CqdHNFcY1h1UYlkVVOHNj10UQbPOHLQWUEVxsMxLpapnfplyuU1ZTJ0GDqxytDzUgTvp+MmUifkd0IIThjN/bu6jggppGTSl7ou/QpCuPml24/lnA22McD4nh8a+Mzx1IzIMuOkOyZFpesYU6kMDwwwXbmoKULKMIUDoa1ephw2/cic4PvgOKCN2Y4IpDssvYxVhl6YSNCY/E5lmGKoUdxsTrs1PEdSgiCW6dKtUwcLnOT+1KmGDYRHwE4MRBAbmHFSj1vuA44SGmOy0iUSQrR83B0b07LuQWexOMow/S6Km8eRg5Y4yDpe8HwxXthRueQqMAeGuG3WNOgWK+3NB9p2TTu4ZLp281SuZ/HQQidJ5JLOp2zFKE6ctMokLY4ScpXNpPBAbm4alzXkyMFYb93MnzGB1uUMIVMu6Zos+mF7qqkBh0xr735uqtdwd/2lU44pmTwIukT69LE0ESnHHZVYkTl4DELlxPC497/N8BrS6uYexlH2wPDLCPEBh0wvJJAjPlYwxUwbb392qudK3P1Kp5RQLmkJv1tImwvAHXSbTmDUmEO6GWmNLri5nxmGCB2Z9sUn73mlU0xoutbSGKyyvxLHvOFD4LqykMkhUkw6w4DgR6aWW/3WZ6YsC+fev+4WEkqBWsNvT6cplzQslAvCBMUhTTT3gDu3P0OGYUIVM7WI9MajXSI9+uquPWI9/FzSpYfimlExDHQMMrJjp1GsijjjnKO89Ushs85ix86I60TiUJFp6fojU8745CAWmzChgeVP9mK14setEu3/VManj6Vi+qgLNcdyZn6wF/gYRo4sa0Fqz5EMhxkrWfgkGtxu/lJrYbIn0Ptf242yJFZY9MVqxU9aRcfaoJfFj66mbQk1ewpehTE3flHjonLIjWuZjnI4gGNxpjbhXtO+GcYcTst07drCZC8++eDfdpPLJV180HI3xPp1Vax2XTx/FfCZ42mIpfYSpx3TKE0y87NOuSPwHMvc+ECn2ArhkKlRDjQXXSeHtm7qYgToykwKdYPXBCnOOx4Z2GRae2N+sheffOjvu8nlkn7rgS6RVv+ti9Wuix++AfjsiSQJtaWYrcNZGFtapxXF9D+OwpdMydpkGZkS9oMsVzdsxCIHGvDTeVWNAS3Fl0Yy5XZQRjA6KePeaOMKSaabr89N9iyl6a295HJJv/lAkFhtRfzg9W08ezKp2F/TnYhPUzk3GfOgK24ilpaiEMI0iDUrZ6kYrEqV1euG7vdJg9Oes7rViahD0ekORBhs0a12BYoONnGQXpp0q2SaYkzpfRXDdWpJr3ifFCacD9+xrb3kckm/cf/BzoS1G5xYbS6ljcaxduZ8pu5pXVf7+n45q5Q6xUnBSq2y08PMWTtTJ2dOFoiOEHXw7ayoTYcdGuPCpFs5g0yBufHeoQ0VTPzr05NWT3SivqeKTw4D5/HrR3sPt/jpm0E245sVl66kak1Ksho5brTqgeeQ3Czto9RHxuR+cdqvoQgxpA2cTkVuUbHhHPCR72n7DI7+qMrwtcockIvESPmX7E5NtoVjc7u0gqNbi26ZOuS6wQi/dHzkeihgjeafbOzp4pODRA2/dl+vNxQ/e7McomdXkVLS4FqnfStgERFzrDJJqFtyS2AhRJO2Bl7nrhXgOZIyUMyN0yGdph0y2ySDa0z9qfmECLhW1RztznqHyt1KYIwhEEi3OMvX2TJtUqfRJrlyNjUMtK34uGHiU//YyyeUS7qJX73vIJf052+VQ8Zqc+LSFV/XKwkQGXDmT6tIt8zcfsRGkO2Wz4+AVWojiByCGAEtvw6FuV7nKCOITKep0+DKtmFaPHncMUEPdBK5pAdE+ou3iz7EwkUat+/luFXT7q2HqWefD0ioHNQGlAo0EBCxKUkvAny313Ygqi7F3W6xgazxQehWqtYZTgoTCSR4dxdL/sq93RSoX75TjCFWOycuXVEOyiQIThI/qMIURCTFmFKYOrSJ38jtF08W/sMxWYsNWpVea5mTO7zk+YKHDpFValPP6P7jrONF5uLnY4+JITd+y9rD6Muf6BLpr97JO2Y3RYVqdDwx2BvMMcqfVu1nL60I2nFzKWT7dGhHx8Io5/05Opa1kKTaoM5k3idO6gHJ60zA8hpEKttpn+Mu6xhRt4BSoOQupisZkXYht1K1BqAQob6PMLvfFTbsI1gvpP/7iCAj7Z5j8n/fcey9ly/6I//vgFToL93TJdJfv5sHaQUgzPZOtl4A/Z9Vx1yfu1jD5RkPKYUSSneU1mSxt01WDvM63GsVqMMoaq7ZpjzNuiEX1Rc+KVt9MF2bed/NMIu+UPqXLQe/5PG6Qw6RHnQqr0Tlub2fpqOcbddvdJ6Str0ZbaD9fVCQbpVInn7tZuvWdsCFqe17Kmjay4ZRJxiyDTy7L7a64QEZyTzTyj7AuQGQ6UWQm3598e4ukb7wHhEpznqI0fNZdUxJppu4PHPo4zYZMmRIBn0LnVxbmJQB/4UY3X7pJi3gUx9f6RHpb24OKntA21tlyJAhwyDhWRxarhp1/ZEpO54SdlvVHStO9YUjBXzqroOZTS/eLJKrcGg33cqQIcN4QrWeqYUbj07JIHz16Ku7djzFjlOp8hpbduxIDrr8r3TEE1sQL91aYewvnyFDhgyjBwD4P9up4aEdRlXvAAAAAElFTkSuQmCC";

    const totalPages = doc.internal.getNumberOfPages();

    // Prepare the string for total pages
    const totalPagesExp = "{total_pages_count_string}";

    // Get the current date and time
    const currentTimestamp = new Date();

    // Get the parts of the timestamp
    const month = currentTimestamp.getMonth() + 1; // Months are zero-indexed
    const day = currentTimestamp.getDate();
    const year = currentTimestamp.getFullYear();
    const hours = currentTimestamp.getHours();
    const minutes = currentTimestamp.getMinutes();

    // Format the date in MM-DD-YYYY
    const formattedDate = `${month < 10 ? "0" : ""}${month}-${
      day < 10 ? "0" : ""
    }${day}-${year}`;

    // Format the time in 24-hour time
    const formattedTime = `${hours < 10 ? "0" : ""}${hours}:${
      minutes < 10 ? "0" : ""
    }${minutes}`;

    // Get the time zone abbreviation (e.g., "EST")
    const timeZoneAbbreviation = new Intl.DateTimeFormat("en-US", {
      timeZoneName: "short",
    })
      .formatToParts(currentTimestamp)
      .find((part) => part.type === "timeZoneName").value;

    // Add the time zone abbreviation to the formatted timestamp
    const timestamp = `${formattedDate} ${formattedTime} ${timeZoneAbbreviation}`;

    // Set styling options for the table
    var options = {
      margin: { top: 30, right: 5, bottom: 10, left: 5 },

      headStyles: {
        halign: "center",
        valign: "middle",
        fontSize: reportTitle === "Item Deficiencies Report" ? 4 : 7,
        fillColor: [68, 99, 159],
        cellWidth: "auto",
      },
      bodyStyles: {
        textColor: 0,
        fontSize: reportTitle === "Item Deficiencies Report" ? 4 : 8,
        overflow:
          reportTitle === "Item Deficiencies Report"
            ? "ellipsize"
            : "linebreak",
        halign: "center",
        cellWidth: "auto",
      },
      columnStyles: {
        0: {
          cellWidth:
            reportTitle === "Item Deficiencies Report"
              ? 20
              : reportTitle === "High Lead Time Report"
              ? 120
              : 40,
          halign: "left",
          overflow: "ellipsize",
        },
        1: {
          halign: "left",
          overflow: "ellipsize",
        },
        20: {
          cellWidth:
            reportTitle === "Item Deficiencies Report" ? "wrap" : "auto",
          halign: "left",
        },
        21: {
          cellWidth:
            reportTitle === "Item Deficiencies Report" ? "wrap" : "auto",
          halign: "left",
        },
      },
      didDrawPage: function (data) {
        // Header
        if (base64Img) {
          doc.addImage(
            base64Img,
            "JPEG",
            data.settings.margin.left,
            10,
            29.175,
            2.85
          );
        }

        var str = "Page " + doc.internal.getNumberOfPages();
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === "function") {
          str = str + " of " + totalPagesExp;
        }
        doc.setFontSize(8);
        var pageSize = doc.internal.pageSize;
        var pageHeight = pageSize.height
          ? pageSize.height
          : pageSize.getHeight();
        doc.text(str, data.settings.margin.left + 270, pageHeight - 5);

        doc.setFont(undefined, "bold");
        doc.setFontSize(16);
        doc.text(reportTitle, 150, 15, {
          align: "center",
        });

        doc.setFontSize(8);
        doc.setFont(undefined, "normal");
        doc.text(projectInfo, 290, 10, {
          align: "right",
        });
        doc.text(projectAddress, 290, 15, {
          align: "right",
        });
        doc.text(`Exported on: ${timestamp}`, 290, 20, {
          align: "right",
        });
      },
      theme: "grid",
    };

    const newColumns = columns.map((column) => {
      const newColumn = { ...column };
      newColumn.header = newColumn.title;
      newColumn.dataKey = newColumn.key;

      if (typeof newColumn.header === "object") {
        newColumn.header = "Status";
      }

      // console.log(newColumn.dataKey, newColumn.key, "Here");

      return newColumn;
    });

    doc.autoTable({
      columns: newColumns,
      body: data,
      ...options,
      didParseCell: function (data) {
        if (data.section === "body") {
          const groupColumnIndex = newColumns.findIndex(
            (col) => col.dataKey === "group"
          );
          if (data.column.index === groupColumnIndex) {
            data.cell.styles.fontStyle = "bold";
          }
        }
      },
    });

    if (typeof doc.putTotalPages === "function") {
      doc.putTotalPages(totalPagesExp);
    }

    return doc.save(`${projectInfo} - ${reportTitle}.pdf`);
  };

  function handleExport() {
    try {
      setExportLoading(true);
      const toastId = toast.loading("Exporting in progress");

      setTimeout(() => {
        PrintTable();
        toast.success("Report exported successfully!", {
          id: toastId,
        });
        setExportLoading(false);
      }, 0);
    } catch (error) {
      console.error("Error:", error);
      toast.dismiss();
      toast.error("Error exporting report. Please try again.");
    }
  }

  return (
    <>
      {editedData.length > 0 ? (
        <Tooltip title="Please save changes before exporting.">
          <div>
            <Button
              className=" d-flex justify-content-left gap-2 align-items-center"
              disabled={
                accessLevel < 2 ||
                isLoading ||
                exportLoading ||
                data.length < 1 ||
                editedData.length > 0
              }
              size="small"
              style={{
                justifyContent: "flex-start",
                display: "flex",
                alignItems: "center",
              }}
              color="default"
              variant="link"
              onClick={handleExport}
            >
              Export to PDF
            </Button>
          </div>
        </Tooltip>
      ) : (
        <Button
          className=" d-flex justify-content-left gap-2  align-items-center"
          color="default"
          variant="link"
          size="small"
          style={{
            justifyContent: "flex-start",
            display: "flex",
            alignItems: "center",
          }}
          disabled={
            accessLevel < 2 ||
            isLoading ||
            exportLoading ||
            data.length < 1 ||
            editedData.length > 0
          }
          onClick={handleExport}
        >
          Export to PDF
        </Button>
      )}
    </>
  );
}

export default ExportReports;
